import { useEffect, useState } from 'react';

import { CartContainer } from '#components/organisms/Carts/CartContainer.js';
import { useShowConsumerCheckout } from '@givebacks/api/store';
import { ActionIcon, CollapsibleCard, Loader, Stack } from 'ui';
import { IconChevronDown, IconChevronUp } from 'ui/Icons';

import type { OrderCheckoutProps } from '../../../../pages/Checkout/order-checkout-types';
import { getCartsInfoFromCheckout } from '../../../../pages/Checkout/utils';

const OrderSummary = ({ checkoutId }: Omit<OrderCheckoutProps, 'onSuccess' | 'cartIds'>) => {
  const [isCartSummaryExpanded, setIsCartSummaryExpanded] = useState(false);

  const {
    data: cartsInfo,
    isSuccess,
    isLoading,
  } = useShowConsumerCheckout({
    checkoutId: checkoutId,
    select: getCartsInfoFromCheckout,
    placeholderData: (prev) => prev,
  });

  useEffect(() => {
    if (isSuccess) {
      setIsCartSummaryExpanded(true);
    }
  }, [isSuccess]);

  return (
    <CollapsibleCard
      isCardExpanded={isCartSummaryExpanded}
      headerTitle="Order Summary"
      endAdornment={
        isLoading ? (
          <Loader />
        ) : (
          <ActionIcon
            c="gray"
            variant="transparent"
            onClick={() => setIsCartSummaryExpanded(!isCartSummaryExpanded)}
          >
            {isCartSummaryExpanded ? (
              <IconChevronUp brand="tabler" />
            ) : (
              <IconChevronDown brand="tabler" />
            )}
          </ActionIcon>
        )
      }
    >
      {/* Note: The collapsible card is not working as expected,
      it is not expanding when the cart is loaded if it's initially loaded.
      This will happen because the  cart container can return null when rendered which makes it so that the collapsible card doesnt expand properly. */}
      <Stack>
        {cartsInfo?.map(({ cartId, storeId, processed_via }) => (
          <CartContainer
            key={cartId}
            id={cartId}
            storeId={storeId}
            showGivingaDisclaimer={processed_via === 'givinga'}
            disableCartItemNameClick={true}
          />
        ))}
      </Stack>
    </CollapsibleCard>
  );
};

export { OrderSummary };
